<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Save Score Tables'"
    :submit-button-text="'SAVE'"
    :reset-modal="resetModal"
    :submit-modal="setScoreTable"
  >
    <b-container>
      <b-row>
        <b-col>
          <p class="tsny_text"></p>
        </b-col>
      </b-row>
      <b-row v-if="setScoreTableError">
        <b-col class="tsny_status-text">
          An error occurred setting the score table for your exam. Note that an
          error will be reported if you attempt to save an existing score table
          without making any changes
        </b-col>
      </b-row>
    </b-container>
  </tsny-modal>
</template>

<script>
import ExamRestService from "../../../services/rest/services/ExamRestService";
import TsnyModal from "../../TsnyModal";

export default {
  name: "SetScoreTableModal",
  components: {
    TsnyModal: TsnyModal
  },
  props: {
    courseId: {
      type: String,
      default: null
    },
    examName: {
      type: String,
      default: null
    },
    scoreTable: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    modalId: "setScoreTableModal",
    setScoreTableError: false
  }),
  methods: {
    resetModal() {
      this.setScoreTableError = false;
    },
    async setScoreTable(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.setScoreTableError = false;
      try {
        await ExamRestService.setScoreTable({
          courseId: this.courseId,
          examName: this.examName,
          scoreTable: this.scoreTable
        });
        this.$bvModal.hide(this.modalId);
      } catch (error) {
        console.log(error);
        this.setScoreTableError = true;
      }
    }
  }
};
</script>

<style scoped></style>
